import TwoLayoutInfo from './TwoLayoutInfo';
import { TwoLayoutInfoDesc } from './TwoLayoutInfoDesc';
import { Col, Row } from 'reactstrap';
import TwoLayoutCard from './TwoLayoutCard';
import { TwoLayoutSectionProps } from '../constants/interface/interface';

const TwoLayoutSection = ({ data }: TwoLayoutSectionProps) => {
  const { info, desc, cards } = data;
  return (
    <>
      <div className="twolayout-section-wrapper">
        <TwoLayoutInfo image={info?.image} para1={info?.para1} para2={info?.para2} />

        {/* <TwoLayoutInfoDesc items={desc} /> */}

        <div className="twolayout-card-wrapper">
          <div className="twolayout-card-container">
            <Row className="custom-twolayout-cardgap">
              {cards?.map((card, index) => (
                <Col lg="6" sm="12" key={index}>
                  <TwoLayoutCard icon={card.icon} heading={card.heading} content={card.content} />
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default TwoLayoutSection;
